<template>
  <div class="boutique">
    <div class="header">
      <section class="hero is-medium">
        <div class="hero-body">
          <div class="">
            <h3 class="title">Boutique</h3>
          </div>
        </div>
      </section>
    </div>
    <div class="boutique-body">
      <h5 class="content">
        Représenter fièrement les couleurs de notre club !
      </h5>

      <a
        class="acces-boutique"
        :href="boutiqueUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        Accéder à la boutique
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoutiqueView",
  data() {
    return {
      boutiqueUrl:
        "https://app.grinta.eu/saint-cyr-herbignac-football/adult/official",
    };
  },
};
</script>

<style lang="scss">
.boutique {
  height: 100%;

  .hero {
    text-align: center;
    h3 {
      margin-left: 0;
    }

    &::before {
      background-image: url("@/assets/hero/boutique2.jpg");
    }
    .title {
      color: #000000;
    }
  }

  .boutique-body {
    text-align: -webkit-center;
    margin-bottom: 40px;

    .content {
      width: 80%;
      font-size: large;
    }

    .acces-boutique {
      display: inline-block;
      margin-top: 20px;
      color: #000000;
      background-color: #ec8a5a;
      border-radius: 10px;
      border: 0;
      cursor: pointer;
      font-weight: bold;
      padding: 12px 24px;
      font-size: large;
      text-decoration: none;
      transition: filter 0.2s ease;

      &:hover {
        filter: brightness(0.95);
      }
    }
  }
}
</style>
